import { z } from "zod";

import { COGNITO_INTERNAL_STAFF_GROUPS } from "@recobra/core";

const internalStaff = COGNITO_INTERNAL_STAFF_GROUPS;

/** Keys become Mongo field names under `requirementProgress`, so no `.` or `$`. */
export const RequirementKeySchema = z
  .string()
  .min(1)
  .max(120)
  .regex(/^[A-Za-z0-9_:-]+$/, "A requirement key may only hold letters, digits, `_`, `:` and `-`.");

const MAX_REQUIREMENT_PATCH_KEYS = 50;

/** A satisfy/waive patch: requirement keys the caller turns on (true) or takes back (false). */
export const RequirementPatchSchema = z
  .record(RequirementKeySchema, z.boolean())
  .refine((patch) => Object.keys(patch).length <= MAX_REQUIREMENT_PATCH_KEYS, {
    message: `At most ${MAX_REQUIREMENT_PATCH_KEYS} requirement keys may be patched at once.`,
  });

const RequirementStampSchema = z.object({
  by: z.string().min(1).describe("Who answered it").meta({ visibleTo: internalStaff }),
  at: z.iso.datetime().meta({ visibleTo: "*" }),
});

/** Every checklist answer the assignee gave on this task. */
export const RequirementProgressSchema = z.object({
  satisfied: z
    .record(z.string(), RequirementStampSchema)
    .default({})
    .describe("Requirement keys that have been met")
    .meta({ visibleTo: "*" }),
  waived: z
    .record(z.string(), RequirementStampSchema)
    .default({})
    .describe(
      "Dismissable rows concluded as a nonexistent document, which stops them blocking completion",
    )
    .meta({ visibleTo: "*" }),
});

export type RequirementProgress = z.infer<typeof RequirementProgressSchema>;
